import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactGA from 'react-ga';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";
import { Row, Col, Typography, Card, Skeleton, Image, Space, Pagination, Empty, Modal, Form, Input, message } from 'antd'
import { menuApplications, unmountMenuApplications, listApplications, unmountListApplications, detailAssessment, unmountAssessment, confirmAssessment, cancelAssessment, rescheduleAssessment } from '../../../../redux/actions/applications/applicationsAction';
import CButton from '../../../../components/Button';
import { listNotification, countNotification } from '../../../../redux/actions/header/headerAction'
import { SafetyOutlined, EnvironmentOutlined } from '@ant-design/icons'
import EmptyLogo from '../../../../assets/img/EmptyLogo.png';
import moment from 'moment';
import MenuApplications from '../Menu';
import { withTranslation } from 'react-i18next';

const { Text } = Typography;
const { TextArea } = Input;

export class index extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
      params: {
        page: 1,
        perpage: 10,
        // phaseId: 12,
        phaseId: 6,
        jobStatus: 'ACTIVE'
      },
      activeKey: "Assessment",
      visible: false,
      visibleDetail: false,
      isReschedule: false,
      isReject: false,
      submitLoading: false,
    }
  }
  
  componentDidMount() {
    const { params } = this.state
    const { actionMenuApplications, actionListApplications } = this.props

    return (actionMenuApplications(), actionListApplications(params))
  }

  handlePagination = (pageNumber) => {
    const { params: { perpage, phaseId, jobStatus } } = this.state
    const params = {
      page: pageNumber,
      perpage: perpage,
      phaseId: phaseId,
      jobStatus: jobStatus
    }
    this.setState({ params })
    window.scrollTo(0, 0);
    const { actionListApplications } = this.props
    return actionListApplications(params)
  }

  showModal = (assessmentId) => {
    const { actionDetailAssessment } = this.props

    const params = {
      assessmentId
    }
    this.setState({
      visible: true
    })

    return actionDetailAssessment(params)
  }

  showModalDetail = (assessmentId) => {
    const { actionDetailAssessment } = this.props

    const params = {
      assessmentId
    }
    this.setState({
      visibleDetail: true
    })

    return actionDetailAssessment(params)
  }

  handleCancel = () => {
    this.setState({
      visible: false,
      visibleDetail: false
    })
  }

  handleShowReschedule = (value) => {
    this.setState({
      isReschedule: value
    })
  }

  handleShowReject = (value) => {
    this.setState({
      isReject: value
    })
  }

  handleAttend = (assessmentId) => {
    const { params } = this.state
    const { actionConfirmAssessment, actionListApplications, actionListNotification, actionCountNotification } = this.props
    
    const values = {
      assessmentId
    }

    const paramsNotification ={
      page: 1,
      perpage: 100
    }

    return this.setState({ submitLoading: true }, () => {
      return actionConfirmAssessment(values, response => {
        if(response.code === '1000'){
          return this.setState({ submitLoading: false, visible: false }, () => {
            message.success(response.message)
            return (actionListApplications(params), actionListNotification(paramsNotification), actionCountNotification())
          })
        }else{
          message.error(response.message)
        }
      }, (err) => {
        return this.setState({ submitLoading: false }, () => message.error(err.message))
      })
    })
  }

  onFinishReschedule = (values, assessmentId) => {
    const { params } = this.state
    const { actionRescheduleAssessment, actionListApplications, actionListNotification, actionCountNotification } = this.props
    
    values.id = assessmentId

    const paramsNotification ={
      page: 1,
      perpage: 100
    }

    return this.setState({ submitLoading: true }, () => {
      return actionRescheduleAssessment(values, response => {
        if(response.code === '1000'){
          return this.setState({ submitLoading: false, visible: false }, () => {
            message.success(response.message)
            return (actionListApplications(params), actionListNotification(paramsNotification), actionCountNotification())
          })
        }else{
          message.error(response.message)
        }
      }, (err) => {
        return this.setState({ submitLoading: false }, () => message.error(err.message))
      })
    })
  }

  onFinishCancel = (values, assessmentId) => {
    const { params } = this.state
    const { actionCancelAssessment, actionListApplications, actionListNotification, actionCountNotification } = this.props
    
    values.id = assessmentId

    const paramsNotification ={
      page: 1,
      perpage: 100
    }

    return this.setState({ submitLoading: true }, () => {
      return actionCancelAssessment(values, response => {
        if(response.code === '1000'){
          return this.setState({ submitLoading: false, visible: false }, () => {
            message.success(response.message)
            return (actionListApplications(params), actionListNotification(paramsNotification), actionCountNotification())
          })
        }else{
          message.error(response.message)
        }
      }, (err) => {
        return this.setState({ submitLoading: false }, () => message.error(err.message))
      })
    })
  }

  render() {
    const { activeKey, visible, visibleDetail, isReschedule, isReject, submitLoading } = this.state
    const { t, getMenuApplications, getListApplications, getDetailAssessment } = this.props

    if(process.env.REACT_APP_ENV === "production"){
      ReactGA.pageview(`${window.location.pathname}${window.location.search}`, [], 'Jobshub - Applications - Assessment');
    }

    const initialProps = {
      activeKey: activeKey
    }

    return (
      <React.Fragment>
        <Helmet>
          <title>Jobshub - Applications - Assessment</title>
        </Helmet>
        <Row className="padding-16">
          <Col className="width-100" md={{ span: 20, offset: 2 }}>
            <Row className="mb-32">
              <Col>
                <Text className="dark-color fs-20">{t('application.applications')}</Text>
              </Col>
            </Row>
            <Row gutter={32}>
              <Col xs={24} lg={4}>
                {
                  getMenuApplications.loading ?
                    <Skeleton active />
                  :
                    <MenuApplications {...this.props} {...initialProps} />
                }
              </Col>
              <Col xs={24} lg={20}>
                <Row className="width-100 mb-8" gutter={8}>
                  <Col span={24}>
                    {
                      getListApplications.data ?
                        <Text className="dark-color fs-13">{`${t('application.assessment.showing')} ${getListApplications?.meta?.total === 0 ? getListApplications?.meta?.total : (getListApplications?.meta?.page*getListApplications?.meta?.perpage)-(getListApplications?.meta?.perpage-1)}-${getListApplications?.meta?.page === getListApplications?.meta?.pages || getListApplications?.meta?.total === 0 ? getListApplications?.meta?.total : getListApplications?.meta?.page*getListApplications?.meta?.perpage} of ${getListApplications?.meta?.total} ${t('application.assessment.job')}`}</Text>
                      :
                        <Skeleton.Input active />
                    }
                  </Col>
                </Row>
                <Row className="mb-16">
                  <Col span={24}>
                    {
                      getListApplications.loading ?
                        <Card className="border-radius-3 box-shadow mb-6">
                          <Skeleton active avatar />
                        </Card>
                      :
                        getListApplications?.data?.length > 0 ?
                          getListApplications?.data?.map((item, i) => 
                            <Card key={i} className="border-radius-3 box-shadow mb-6">
                              <Row className="width-100" gutter={16} style={{ marginBottom: -10 }}>
                                <Col className="col-img-job" xs={24} sm={4} md={4}>
                                  {/* <Link to={`/candidate/company/${item.companyId}/${item.companyType}`}> */}
                                  <Link to={`/candidate/job/detail/${item.slug}`}>
                                    <Image
                                      src={item.companyLogoUrl ? item.companyLogoUrl : EmptyLogo}
                                      preview={false}
                                      width={'100%'}
                                      height={80}
                                      style={{ objectFit: 'contain' }}
                                    />
                                  </Link>
                                </Col>
                                <Col xs={24} sm={13} md={12}>
                                  <Space direction="vertical" size={0}>
                                    <Link to={`/candidate/job/detail/${item.slug}`}>
                                      <Text className="info-color fs-17">{item.title}</Text>
                                    </Link>
                                    <Text className="fs-13 dark-color">{item.companyName} {item.isVerified ? <SafetyOutlined className="primary-color" /> : null}</Text>
                                    <Text className="fs-13 dark-color"><EnvironmentOutlined /> {item.jobDestinationParentId ? `${item.jobDestinationName}, ${item.jobDestinationParentName}` : item.jobDestinationName}</Text>
                                  </Space>
                                </Col>
                                <Col xs={24} sm={7} md={8} className="application-date">
                                  <Space direction="vertical" size={8} className="application-date">
                                    <Text className="application-date fs-13 dark-color">{`${t('application.assessment.applied')} ${item.applyDate}`}</Text>
                                    {
                                      item.assessmentStatus === 'WAITING_CONFIRM' || item.assessmentStatus === 'RESCHEDULE_ADMIN' ?
                                        <CButton className="application-date mt-8 fs-12" type="primary-icon" icon="CalendarOutlined" action={() => this.showModal(item.assessmentId)} title={t('application.assessment.confirm')}/>
                                      : item.assessmentStatus === 'CONFIRM' || item.assessmentStatus === 'RESCHEDULE_CANDIDATE' ?
                                        <CButton className="btn-info application-date mt-8 fs-12" type="primary" action={() => this.showModalDetail(item.assessmentId)} title= {t('application.assessment.details')}/>
                                      :
                                        null
                                    }
                                    <Modal title={t('application.assessment.title')} width={700} visible={visible} onCancel={this.handleCancel} footer={false} destroyOnClose>
                                      {
                                        getDetailAssessment.loading ?
                                          <Skeleton active />
                                        :
                                          <React.Fragment>
                                            <Space className="width-100" direction="vertical">
                                              <Text className="dark-color fs-14">{t('application.assessment.thankyou')} {getDetailAssessment?.data?.jobPositionName} - {getDetailAssessment?.data?.companyName}.</Text>
                                              <Text className="dark-color fs-14">{t('application.assessment.title2')}</Text>
                                              <Row className="mb-8" gutter={16}>
                                                <Col xs={6} lg={3}>
                                                  <Text>{t('application.assessment.date')}</Text>
                                                </Col>
                                                <Col xs={18} lg={21}>
                                                  <Space align="start" style={{ textAlign: 'justify' }}>
                                                    <Text>:</Text>
                                                    <Text className="font-weight-bold">{moment(getDetailAssessment?.data?.assessmentDate, 'DD/MM/YYYY').format('DD MMMM YYYY')}</Text>
                                                  </Space>
                                                </Col>
                                                <Col xs={6} lg={3}>
                                                  <Text>{t('application.assessment.time')}</Text>
                                                </Col>
                                                <Col xs={18} lg={21}>
                                                  <Space align="start" style={{ textAlign: 'justify' }}>
                                                    <Text>:</Text>
                                                    <Text className="font-weight-bold">{moment(getDetailAssessment?.data?.assessmentTime, 'hh:mm:ss').format('LT')}</Text>
                                                  </Space>
                                                </Col>
                                                {
                                                  getDetailAssessment?.data?.isMethod &&
                                                  <React.Fragment>
                                                    <Col xs={6} lg={3}>
                                                      <Text>{t('application.assessment.location')}</Text>
                                                    </Col>
                                                    <Col xs={18} lg={21}>
                                                      <Space align="start" style={{ textAlign: 'justify', marginBottom: -12 }}>
                                                        <Text>:</Text>
                                                        <div className="font-weight-bold" dangerouslySetInnerHTML={{ __html: getDetailAssessment?.data?.location }}></div>
                                                      </Space>
                                                    </Col>
                                                  </React.Fragment>
                                                }
                                                {
                                                  !getDetailAssessment?.data?.isMethod &&
                                                  <React.Fragment>
                                                    <Col xs={6} lg={3}>
                                                      <Text>{t('application.assessment.virtualLink')}</Text>
                                                    </Col>
                                                    <Col xs={18} lg={21}>
                                                      <Space align="start" style={{ textAlign: 'justify', marginBottom: -12 }}>
                                                        <Text>:</Text>
                                                        <div className="font-weight-bold" dangerouslySetInnerHTML={{ __html: getDetailAssessment?.data?.virtualLink }}></div>
                                                      </Space>
                                                    </Col>
                                                  </React.Fragment>
                                                }
                                                <Col xs={6} lg={3}>
                                                  <Text>{t('application.assessment.notes')}</Text>
                                                </Col>
                                                <Col xs={18} lg={21}>
                                                  <Space align="start" style={{ textAlign: 'justify', marginBottom: -12 }}>
                                                    <Text>:</Text>
                                                    <div className="font-weight-bold" dangerouslySetInnerHTML={{ __html: getDetailAssessment.data.notes ? getDetailAssessment.data.notes : '-' }}></div>
                                                  </Space>
                                                </Col>
                                              </Row>
                                              {
                                                !isReschedule?
                                                  <Space className="mb-8">
                                                    <CButton className="fs-12" type="primary" disabled={isReject} action={() => this.handleAttend(getDetailAssessment?.data?.id)} title={t('application.assessment.attend')}/>
                                                    <CButton className={!isReject ? "btn-info fs-12" : "fs-12"} type="primary" disabled={isReject} action={() => this.handleShowReschedule(getDetailAssessment?.data?.id)} title={t('application.assessment.reschedule')}/>
                                                    {/* <Button className="fs-12 border-radius-3" type="primary" disabled={isReject} onClick={() => this.handleAttend(getDetailAssessment?.data?.id)}>{t('application.assessment.attend')}</Button>
                                                    <Button className={!isReject ? "btn-info fs-12 border-radius-3" : "fs-12 border-radius-3"} disabled={isReject} onClick={() => this.handleShowReschedule(getDetailAssessment?.data?.id)}>{t('application.assessment.reschedule')}</Button> */}
                                                  </Space>
                                                :
                                                  null
                                              }
                                            </Space>
                                            {
                                              !isReschedule && !isReject ?
                                                <Text className="dark-color fs-14">{t('application.assessment.title3')} <Text className="info-color cursor-pointer" onClick={() => this.handleShowReject(true)}>{t('application.assessment.clickHere')} </Text></Text>
                                              : isReschedule ? 
                                                <Form 
                                                  ref={this.formRef}
                                                  onFinish={(values) => this.onFinishReschedule(values, getDetailAssessment?.data?.id)}
                                                >
                                                  <Space size={4}>
                                                    <Text className="fs-12" type="danger">*</Text>
                                                    <Text className="fs-12" type="secondary">{t('application.assessment.rescheduleTitle')}</Text>
                                                  </Space>
                                                  <Form.Item 
                                                    name="rescheduleReason"
                                                    rules={[
                                                      { required: true, message: 'Reschedule reason is mandatory' }
                                                    ]}
                                                  >
                                                    <TextArea rows={3} />
                                                  </Form.Item>
                                                  <Form.Item>
                                                    <Space className="float-right">
                                                      <CButton className="fs-12" type="default" action={() => this.handleShowReschedule(false)} title={t('application.assessment.cancel')}/>
                                                      <CButton className="fs-12" htmlType="submit" type="primary" loading={submitLoading} title={t('application.assessment.reschedule')}/>
                                                      {/* <Button className="fs-12 border-radius-3" type="default" onClick={() => this.handleShowReschedule(false)}>{t('application.assessment.cancel')}</Button>
                                                      <Button className="fs-12 border-radius-3" htmlType="submit" type="primary" loading={submitLoading}>{t('application.assessment.reschedule')}</Button> */}
                                                    </Space>
                                                  </Form.Item>
                                                </Form>
                                              : isReject ? 
                                                <Form 
                                                  ref={this.formRef}
                                                  onFinish={(values) => this.onFinishCancel(values, getDetailAssessment?.data?.id)}
                                                >
                                                  <Space size={4}>
                                                    <Text className="fs-12" type="danger">*</Text>
                                                    <Text className="fs-12" type="secondary">{t('application.assessment.decline')}</Text>
                                                  </Space>
                                                  <Form.Item 
                                                    name="candidateNote"
                                                    rules={[
                                                      { required: true, message: 'Decline reason is mandatory' }
                                                    ]}
                                                  >
                                                    <TextArea rows={3} />
                                                  </Form.Item>
                                                  <Form.Item>
                                                    <Space className="float-right">
                                                      <CButton className="fs-12" type="default" action={() => this.handleShowReject(false)} title={t('application.assessment.cancel')}/>
                                                      <CButton lassName="fs-12" htmlType="submit" type="danger" loading={submitLoading} title={t('application.assessment.declineInvite')}/>
                                                      {/* <Button className="fs-12 border-radius-3" type="default" onClick={() => this.handleShowReject(false)}>{t('application.assessment.cancel')}</Button>
                                                      <Button className="fs-12 border-radius-3" htmlType="submit" type="danger" loading={submitLoading}>{t('application.assessment.declineInvite')}</Button> */}
                                                    </Space>
                                                  </Form.Item>
                                                </Form>
                                              :
                                                null
                                            }
                                          </React.Fragment>
                                        }
                                    </Modal>
                                    <Modal 
                                      title={
                                        getDetailAssessment.loading ?
                                          <Skeleton paragraph={{ rows: 1 }} active />
                                        :
                                          <Space className="text-align-center width-100" direction="vertical">
                                            <Text className="fs-20 primary-color">{t('application.assessment.assessmentDetail')} </Text>
                                            <Text className="fs-15 dark-color">{`${getDetailAssessment?.data?.jobPositionName} - ${getDetailAssessment?.data?.companyName}`}</Text>
                                          </Space>
                                      } 
                                      width={800}
                                      visible={visibleDetail} 
                                      onCancel={this.handleCancel}
                                      footer={false}
                                    >
                                      {
                                        getDetailAssessment.loading ?
                                          <Skeleton active />
                                        :
                                          <React.Fragment>
                                            <Space className="width-100" direction="vertical">
                                              <Row className="mb-32" gutter={16}>
                                              <Col xs={10} lg={5}>
                                                  <Text>{t('application.assessment.status')}</Text>
                                                </Col>
                                                <Col xs={14} lg={19}>
                                                  <Space align="start" style={{ textAlign: 'justify' }}>
                                                    <Text>:</Text>
                                                    <Text strong className="font-style-italic">{getDetailAssessment?.data?.assessmentStatusNote}</Text>
                                                  </Space>
                                                </Col>
                                                {
                                                  getDetailAssessment?.data?.rescheduleReason &&
                                                  <React.Fragment>
                                                    <Col xs={10} lg={5}>
                                                      <Text>{t('application.assessment.rescheduleReason')}</Text>
                                                    </Col>
                                                    <Col xs={14} lg={19}>
                                                      <Space align="start" style={{ textAlign: 'justify' }}>
                                                        <Text>:</Text>
                                                        <Text strong> {getDetailAssessment?.data?.rescheduleReason}</Text>
                                                      </Space>
                                                    </Col>
                                                  </React.Fragment>
                                                }
                                                <Col xs={10} lg={5}>
                                                  <Text>{t('application.assessment.date')}</Text>
                                                </Col>
                                                <Col xs={14} lg={19}>
                                                  <Space align="start" style={{ textAlign: 'justify' }}>
                                                    <Text>:</Text>
                                                    <Text strong> {moment(getDetailAssessment?.data?.assessmentDate, 'DD/MM/YYYY').format('DD MMMM YYYY')}</Text>
                                                  </Space>
                                                </Col>
                                                <Col xs={10} lg={5}>
                                                  <Text>{t('application.assessment.time')}</Text>
                                                </Col>
                                                <Col xs={14} lg={19}>
                                                  <Space align="start" style={{ textAlign: 'justify' }}>
                                                    <Text>:</Text>
                                                    <Text strong> {moment(getDetailAssessment?.data?.assessmentTime, 'hh:mm:ss').format('LT')}</Text>
                                                  </Space>
                                                </Col>
                                                {
                                                  getDetailAssessment?.data?.isMethod &&
                                                  <React.Fragment>
                                                    <Col xs={10} lg={5}>
                                                      <Text>{t('application.assessment.location')}</Text>
                                                    </Col>
                                                    <Col xs={14} lg={19}>
                                                      <Space align="start" style={{ textAlign: 'justify', marginBottom: -12 }}>
                                                        <Text>:</Text>
                                                        <div className="font-weight-bold" dangerouslySetInnerHTML={{ __html: getDetailAssessment?.data?.location }}></div>
                                                      </Space>
                                                    </Col>
                                                  </React.Fragment>
                                                }
                                                {
                                                  !getDetailAssessment?.data?.isMethod &&
                                                  <React.Fragment>
                                                    <Col xs={10} lg={5}>
                                                      <Text>{t('application.assessment.virtualLink')}</Text>
                                                    </Col>
                                                    <Col xs={14} lg={19}>
                                                      <Space align="start" style={{ textAlign: 'justify', marginBottom: -12 }}>
                                                        <Text>:</Text>
                                                        <div className="font-weight-bold" dangerouslySetInnerHTML={{ __html: getDetailAssessment?.data?.virtualLink }}></div>
                                                      </Space>
                                                    </Col>
                                                  </React.Fragment>
                                                }
                                                <Col xs={10} lg={5}>
                                                  <Text>{t('application.assessment.notes')}</Text>
                                                </Col>
                                                <Col xs={14} lg={19}>
                                                  <Space align="start" style={{ textAlign: 'justify', marginBottom: -12 }}>
                                                    <Text>:</Text>
                                                    <div className="font-weight-bold" dangerouslySetInnerHTML={{ __html: getDetailAssessment.data.notes ? getDetailAssessment.data.notes : '-' }}></div>
                                                  </Space>
                                                </Col>
                                              </Row>
                                              <Space className="float-right">
                                                <CButton className="fs-12" type="primary" onClick={this.handleCancel} title={t('application.assessment.okay')}/>
                                                {/* <Button className="fs-12 border-radius-3" type="primary" onClick={this.handleCancel}>{t('application.assessment.okay')}</Button> */}
                                              </Space>
                                            </Space>
                                          </React.Fragment>
                                        }
                                    </Modal>
                                  </Space>
                                </Col>
                              </Row>
                          </Card>
                      )
                        :
                          <Card className="border-radius-3 box-shadow mb-6">
                            <Empty />
                          </Card>
                    }
                  </Col>
                </Row>
                <Row>
                  <Col className="text-align-center" span={24}>
                    <Pagination onChange={this.handlePagination} current={getListApplications?.meta?.page} pageSize={getListApplications?.meta?.perpage || 10} total={getListApplications?.meta?.total} />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </React.Fragment>
    )
  }
  componentWillUnmount(){
    const { unmountMenuApplications, unmountListApplications, unmountAssessment } = this.props
    return (unmountMenuApplications(), unmountListApplications(), unmountAssessment())
  }
}

const mapStateToProps = (state) => ({
  getMenuApplications: state.menuApplicationsReducer,
  getListApplications: state.listApplicationsReducer,
  getDetailAssessment: state.assessmentReducer
})

const mapDispatchToProps = {
  actionMenuApplications: menuApplications,
  unmountMenuApplications: unmountMenuApplications,
  actionListApplications: listApplications,
  unmountListApplications: unmountListApplications,
  actionDetailAssessment: detailAssessment,
  unmountAssessment: unmountAssessment,
  actionConfirmAssessment: confirmAssessment,
  actionCancelAssessment: cancelAssessment,
  actionRescheduleAssessment: rescheduleAssessment,
  actionListNotification: listNotification,
  actionCountNotification: countNotification
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(index))